<template>
  <transition name="modal-fade" class="modal-fade">
    <div class="modal-backdrop">
      <form @submit.prevent="addMapping" action="#" method="post">
        <div class="exit-mapping-convo-modal" role="dialog" aria-labelledby="modalTitle"
          aria-describedby="modalDescription">
          <header class="modal-header">
            <slot name="header">Exit Mapping for label</slot>            
          </header>
          <section class="exit-mapping-convo-modal-body">
            <div v-for="(item, index) in conversationExitMapping" :key="index">
              <div class="panel panel-default panel-group-container">
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-12 col-lg-12 col-xs-12 keyword-conversation-container">
                      <div class="form-group col-xs-6 col-sm-6 col-md-6">
                        <label class="nlp-convo-exit-mapping-label">Exit Conversation Name</label>
                        <treeselect placeholder="--Choose a conversation--" :multiple="false"
                          :options="conversationList" v-model="item.parent_conversation_id"
                          @input="updateStageList(item, index)" />
                          <span v-if="errors[index] && errors[index].parentConversationError" class="text-danger">
                            {{ errors[index].parentConversationError }}
                          </span>
                      </div>
                      <div class="form-group col-xs-6 col-sm-6 col-md-6">
                        <label class="nlp-convo-exit-mapping-label">Redirection Stage</label>
                        <treeselect placeholder="--Choose a stage--" :multiple="false" :options="item.stageList"
                          v-model="item.stage" />
                          <span v-if="errors[index] && errors[index].stageError" class="text-danger">
                            {{ errors[index].stageError }}
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <footer class="modal-footer">
            <slot name="footer">
              <button type="button" class="btn btn-primary" @click="close(true)">Cancel</button>
              <button type="button" class="btn btn-primary" @click="saveMapping">Save</button>
            </slot>
          </footer>
        </div>
      </form>
      <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br />Please wait...</BlockUI>
    </div>
  </transition>
</template>

<script>
import api from '../../../utils/api'
import { cloneDeep } from 'lodash'
export default {
  name: 'NlpConversationExitMapping',
  props: ['conversationList', 'labelMappingId', 'conversationExitMapping', 'additionalTopicMappingDetails'],
  data () {
    return {
      confirmationMessage: 'Are you sure you want to delete this label conversation mapping?',
      actionToBePerformed: 'Add Topic Label mapping',
      isDeleteConfirmationVisible: false,
      rowIndexToBeUpdated: 0,
      loading: false,
      labels: [],
      errors: [],
      initialConversationExitMapping: []
    }
  },
  async mounted () {
    this.initialConversationExitMapping = cloneDeep(this.conversationExitMapping)
    console.log('Initial Conversation Exit Mapping during mounted phase:', this.initialConversationExitMapping)
    await this.populateStageList()
  },
  methods: {
    async populateStageList () {
      console.log('this.conversationExitMapping: ', this.conversationExitMapping)
      if (this.conversationExitMapping.length > 0) {
        const conversationIds = this.conversationExitMapping.map((item) => {
          return item.parent_conversation_id
        })
        if (!conversationIds || conversationIds.length === 0 || !conversationIds[0]) return
        console.log('conversationIds: ', conversationIds, conversationIds.length)
        const stageListResponse = await api.buildRequest(`get-app-config/${conversationIds}`, 'GET', {})
        if (stageListResponse.data.payload && stageListResponse.data.payload.length > 0) {
          stageListResponse.data.payload.forEach((item) => {
            this.conversationExitMapping.forEach((mappingItem, index) => {
              if (item.id === mappingItem.parent_conversation_id) {
                const newStageList = Object.keys(item.conversation_config.config.stages).map(stage => ({
                  id: stage,
                  label: stage
                }))
                this.$set(this.conversationExitMapping[index], 'stageList', newStageList)
              }
            })
          })
        } else {
          console.log('No stage list found for the selected conversation')
        }
      }
      console.log('Conversation Exit Mapping:')
      console.log(this.conversationExitMapping)
    },
    addNewMapping () {
      console.log('Adding new mapping')
      this.conversationExitMapping.push({
        parent_conversation: null,
        stage: null,
        parent_conversation_id: null,
        stageList: [{
          id: null,
          label: null
        }]
      })
    },
    validateForm () {
      let isValid = true
      this.errors = [] // Clear previous errors

    // Initialize a Set to track unique parent_conversation_ids
      let seenParentConversationIds = new Set()

      this.conversationExitMapping.forEach((item, index) => {
          // Clear previous errors for each dropdown
        let parentConversationError = null
        let stageError = null

        // Check for errors in the "parent_conversation_id"
        if (!item.parent_conversation_id) {
          parentConversationError = 'Parent conversation is required.'
          isValid = false
        } else if (seenParentConversationIds.has(item.parent_conversation_id)) {
          parentConversationError = 'Parent conversation ID must be unique.'
          isValid = false
        } else {
          // Mark the parent_conversation_id as seen
          seenParentConversationIds.add(item.parent_conversation_id)
        }

        // Check for errors in the "stage"
        if (!item.stage) {
          stageError = 'Stage is required.'
          isValid = false
        }

        // Push the errors for each dropdown separately
        this.$set(this.errors, index, { parentConversationError, stageError })
      })

      return isValid
    },
    async saveMapping () {
      // if (!this.validateForm()) {
      //   console.log('Form validation failed')
      //   return
      // }
      console.log('Label Mapping Id:', this.labelMappingId)
      console.log('this.conversationExitMapping:', this.conversationExitMapping)
      this.loading = true
      const updateObject = {
        additionalTopicMappingDetails: this.additionalTopicMappingDetails,
        mappingId: this.labelMappingId,
        conversationExitMapping: this.conversationExitMapping.map((item) => {
          return {
            parent_conversation: item.parent_conversation,
            stage: item.stage,
            parent_conversation_id: item.parent_conversation_id
          }
        })
      }
      console.log('Update Object:', updateObject)
      console.log('newExitMapping: ', this.conversationExitMapping)
      await api.buildRequest('save-nlp-exit-mapping', 'POST', updateObject).then(() => {
        console.log('Updating the mapping in the parent component...')
        const newExitMapping = cloneDeep(this.conversationExitMapping).filter(item => item.parent_conversation_id && item.stage)
        console.log('newExitMapping: ', newExitMapping)
        this.$emit('updateConversationExitMapping', newExitMapping, this.labelMappingId)
      }).catch((error) => {
        console.error('Error saving mapping:', error)
        this.loading = false
      }).finally(() => {
        this.loading = false
        this.close(false)
      })
    },
    removeMapping (index) {
      console.log('Removing mapping at index:', index)
      this.conversationExitMapping.splice(index, 1)
    },
    loadStageList (currentItem) {
      console.log('Load options...')
      console.log(currentItem)
    },
    close (shouldEmitUpdate) {
      this.$emit('close')
      if (shouldEmitUpdate) {
        const newExitMapping = cloneDeep(this.initialConversationExitMapping).filter(item => item.parent_conversation_id && item.stage)
        this.$emit('updateConversationExitMapping', newExitMapping, this.labelMappingId)
      }
    },
    addMapping () {
      this.close(false)
    },
    async updateStageList (selectedItem, currentMappingIndex) {
      console.log('Something changed in the conversation list')
      console.log(selectedItem)

      this.$nextTick(async () => {
        const selectedConversationId = selectedItem.parent_conversation_id
        console.log('Selected Conversation ID:', selectedConversationId)

        // Make sure conversation_id is not null
        if (selectedConversationId) {
          const fetchAppConfig = await api.buildRequest(`get-app-config/${selectedConversationId}`, 'GET', {})
          console.log('Response:', fetchAppConfig.data.payload)
          if (fetchAppConfig.data.payload && fetchAppConfig.data.payload.length > 0 &&
              fetchAppConfig.data.payload[0].conversation_config &&
              fetchAppConfig.data.payload[0].conversation_config.config &&
              fetchAppConfig.data.payload[0].conversation_config.config.stages &&
              Object.keys(fetchAppConfig.data.payload[0].conversation_config.config.stages).length > 0) {
            const config = Object.keys(fetchAppConfig.data.payload[0].conversation_config.config.stages)
            console.log('Config:', config)
            const newStageList = config.map((stage) => {
              return {
                id: stage,
                label: stage
              }
            })
            const selectedConversation = this.conversationList.find((item) => {
              return item.id === selectedConversationId
            })
            console.log('Selected Conversation:', selectedConversation)
            this.conversationExitMapping.forEach((mappingItem, index) => {
              if (mappingItem.parent_conversation_id === selectedConversationId) {
                // this.$set(this.conversationExitMapping[index], 'stageList', config)
                this.$set(this.conversationExitMapping, currentMappingIndex, Object.assign({}, mappingItem, {
                  stageList: newStageList,
                  parent_conversation: selectedConversation.label,
                  stage: null,
                  parent_conversation_id: selectedConversationId
                }))
              }
            })
          } else {
            console.log('No stage list found for the selected conversation')
          }
        } else {
          // set stage list to null if no conversation selected
          this.conversationExitMapping[currentMappingIndex].stageList = []
          this.conversationExitMapping[currentMappingIndex].stage = null
          console.log('Conversation ID is null')
        }
      })
    }
  }
}
</script>


<style>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.exit-mapping-convo-modal {
  background: #FFFFFF;
  box-shadow: 2px 2px 20px 1px;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 30px;
  width: 70%;
  border-radius: 8px;
}

.modal-header,
.modal-footer {
  padding: 15px;
  text-align: center;
  font-size: 20px;
}

.exit-mapping-convo-modal-body {
  padding: 10px 15px;
}

.select-container {
  display: flex;
  justify-content: space-between;
  /* This ensures the selects are side by side */
  gap: 20px;
  /* Space between the select items */
}

.select-item {
  flex: 1;
  /* Ensures each select takes equal space */
}

.nlp-convo-exit-mapping-label {
  font-size: 14px;
  display: block;
  margin-bottom: 5px;
}

.select-field {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.modal-footer {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.btn-close {
  border: none;
  font-size: 20px;
  cursor: pointer;
  background: transparent;
}

.btn-green {
  color: white;
  background: #0D9488;
  border: 1px solid #0D9488;
  border-radius: 4px;
  padding: 8px 12px;
}

.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity .5s ease;
}

.dropdown-loader-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
}

.dropdown-loader {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: spin 2s linear infinite;
}

.add-exit-mapping-button {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.exit-mapping-error {
  color: red;
  font-size: 12px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// nlpConversationExitMapping.vue?637eba51